import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Logo } from '../assets/images'
import authContext from '../context/auth-context'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const Container = styled.div`
  display:flex;
  flex-direction:row;
  justify-content:space-evenly;
  padding:50px;
  div{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    padding:60px 20px;
    width:48%;
    img{
      width: ${props => props.register ? '80%' : '80%'};
      height: ${props => props.register ? '60%' : '90%'};
    }
  }

  form{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    width:100%;
  }

  h4{
    font-size:40px;
    letter-spacing:1.2px;
    margin-bottom:40px;
  }

  h5{
    color:crimson;
    font-size:14px;
    font-weight:500;
  }

  input{
    padding:10px;
    padding-left:40px;
    width:80%;
    margin:10px 0px;
    border-radius:6px;
    font-family:inherit;
    border:2px solid rgba(77,75,50,0.72);
    color:white;
    &:active, &:focus{
      outline:1px solid #FCDA8B;
    }
  }

  button{
    align-self:'center';
    color:white;
    width:80%;
    padding:10px;
    background: rgba(77,75,50,0.72);
    border-radius:5px;
    font-weight:500;
    font-size:16px;
    border: 1px solid rgba(77,75,50,0.72);
    transition: all 0.3s ease-in-out;
    margin:20px 0px;
    &:hover{
        background: #FCDA8B;
        border: 1px solid #FCDA8B;
        color:black;
        font-weight:500;
        cursor:pointer;
    }
    &:active{
      transform: scale(0.96);
      animation: all 0.7s ease-in-out;
    }
  }

  p{
    span{
      &:hover{
        cursor:pointer;
      }
    }
  }
  
  @media screen and (max-width: 768px) {
    padding:0px;
    .mobile-responsive{
      display:none;
      visibility: none;
    }
    div{
      width: 80%;
    }
    input, button{
      width: 100%;
    }
  }
  @media screen and (max-width: 500px) {
    .mobile-responsive{
      display:none;
      visibility: none;
    }
    div{
      width: 100%;
    }
    input, button{
      width: 100%;
    }
  }
  @media screen and (min-width: 770px) {
    .mobile-responsive{

    }
  }
`

const Authentication = () => {
  const [isRegister, setIsRegister] = useState(false)
  const {login, register, state, userInfo} = useContext(authContext)
  const navigate = useNavigate()
  const [data, setData] = useState(
    {username:'', fullName:'', email:'', password:'', repassword:''}
  )
  const LoginHandler = (e) => {
    e.preventDefault()
    login(data)
  }

  const RegisterHandler = (e) => {
    e.preventDefault()
    register(data)
  }
  useEffect(()=>{
    if(state.userInfo || userInfo){
      navigate('/')
      setData((
        {username:'', fullName:'', email:'', password:'', repassword:''}
      ))
    }
    if(state.userRegistered !== undefined && state.userRegistered){
      setIsRegister(false)
      toast(`Email Subscribed successfully`, {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setData((
        {username:'', email:'', password:'', repassword:''}
      ))
    }
    // eslint-disable-next-line
  },[state?.userInfo, state?.userRegistered])

  
  return (
    <Container register={isRegister}>
      <div className='mobile-responsive'>
        <img src={Logo} alt='logo' />
      </div>
      <div>
        {isRegister ? 
        <form onSubmit={RegisterHandler}>
          <h4>Register</h4>
          {state?.error && <h5>{state.error.response.data.detail}</h5>}
          <input required value={data.username} onChange={(e)=>setData({...data, username:e.target.value})} placeholder='Username'/>
          <input required value={data.fullName} onChange={(e)=>setData({...data, fullName:e.target.value})} placeholder='Full Name'/>
          <input required value={data.email} onChange={(e)=>setData({...data, email:e.target.value})} type='email' placeholder='Email'/>
          <input required value={data.password} onChange={(e)=>setData({...data, password:e.target.value})} type='password' placeholder='Password'/>
          <input required value={data.repassword} onChange={(e)=>setData({...data, repassword:e.target.value})} type='password' placeholder='Repeat Password'/>
          <button disabled={state?.registerLoading}>{state?.registerLoading ? 'Redirecting' : 'Register'}</button>
          <p>Already Registred ? <span onClick={()=>setIsRegister(!isRegister)}>Let's Login.</span></p>
        </form>
        :
        <form onSubmit={LoginHandler}>
          <h4>Login</h4>
          {state?.error && <h5>{state.error.response.data.detail}</h5>}
          <input required value={data.username} onChange={(e)=>setData({...data, username:e.target.value})} placeholder='Username'/>
          <input required value={data.password} onChange={(e)=>setData({...data, password:e.target.value})} type='password' placeholder='Password'/>
          <button disabled={state?.authLoading} type='submit'>{state?.authLoading ? 'Registering' : 'Login'}</button>
          <p>New User ? <span onClick={()=>setIsRegister(!isRegister)}>Let's Register.</span></p>
        </form>
        }
      </div>
    </Container>
  )
}

export default Authentication